// extracted by mini-css-extract-plugin
module.exports = {"textAlignCenter":"_27RvB","textAlignLeft":"_1yYH4","textAlignRight":"_2eJ87","textAlignJustify":"fDpg5"};